module.exports = __webpack_public_path__ + "img/document-accept-1.377adb38.svg";